import axios from 'axios';

let axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_STRAPI_BACKEND_BASE_URL,
  method: 'GET',
  timeout: 50000,
  headers: {
    auth: 'Bearer ' + process.env.VUE_APP_STRAPI_AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
});

class Helptopics {
  static helpTopics(helpTopicParam: any) {
    return axiosInstance.get('/selfcare-help-topic-list', {
      params: {
        popular: helpTopicParam.popular,
        _limit: helpTopicParam.limit,
        categories: helpTopicParam.categories,
        sub_categories_1: helpTopicParam.sub_categories_1,
        sub_categories_2: helpTopicParam.sub_categories_2,
        sub_categories_3: helpTopicParam.sub_categories_3,
        sub_categories_4: helpTopicParam.sub_categories_4,
        language: helpTopicParam.language,
      },
    });
  }

  /* helptopic search */
  static searchHelpListTopics(searchVal: any) {
    return axiosInstance.get('/selfcare-help-topic-list', {
      params: {
        searchText: searchVal.searchText,
        filter: searchVal.filter,
        lang: searchVal.lang,
      },
    });
  }

  static searchHelpTopics(searchVal: any) {
    return axiosInstance.get('/selfcare-help-topic-generic-search-list', {
      params: {
        language: searchVal.language,
        _q: searchVal.searchText,
      },
    });
  }

  static serviceDownImage(bannerParam) {
    return axiosInstance.get('/selfcare-filtered-data', {
      params: {
        categories: bannerParam.categories,
        sub_categories_1: bannerParam.sub_categories_1,
        status: true,
        from_date_time_lte: bannerParam.from_date_time_lte,
        to_date_time_gte: bannerParam.to_date_time_gte,
      },
    });
  }
}

export default Helptopics;
